var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal-target',{staticClass:"popup-layer",attrs:{"name":"popup","multiple":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }